import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { ReportSectionHeader } from "../SectionHeader";


const SettlementRateDistributionComponent = (props) => (
	<div>
		<ReportSectionHeader>
			Applicable Settlement Rate Distribution Based on Magnitude of Potential Damages
		</ReportSectionHeader>

		<ReportTable
			settings={
			[
				{
					header: `Estimated Maximum Potentially Available Rule 10b-5 Aggregate Damages Band \n(000s)`,
					accessor: 'settlementRateBandLabel',
					centerWideJustified: true,
					centerRightJustified: false
					
				},
				{
					header: '10th Percentile',
					accessor: 'settlementRate10Value',
					round2Decimal: true,
					percentageSign: true,
					percentageNumber: true
				},
				{
					header: '25th Percentile',
					accessor: 'settlementRate25Value',
					round2Decimal: true,
					percentageSign: true,
					percentageNumber: true
				},
				{
					header: 'Median Ratio',
					accessor: 'settlementRateValue',
					round2Decimal: true,
					percentageSign: true,
					percentageNumber: true
				},
				{
					header: '75th Percentile',
					accessor: 'settlementRate75Value',
					round2Decimal: true,
					percentageSign: true,
					percentageNumber: true
				},
				{
					header: '90th Percentile',
					accessor: 'settlementRate90Value',
					round2Decimal: true,
					percentageSign: true,
					percentageNumber: true
				},
				{
					header: 'Mean Ratio',
					accessor: 'settlementRateMeanValue',
					round2Decimal: true,
					percentageSign: true,
					percentageNumber: true
				}
			]

			}
			data={props.currentSettlementRateBand}
			name={"currentSettlementRateBand"}

		/>
		<p />
		
	</div>
);


export default SettlementRateDistributionComponent;



// WEBPACK FOOTER //
// ./src/common/components/SettlementRateDistribution/SettlementRateDistributionComponent.js